<template>
  <div class="d-flex flex-column g-4">
    <InputView type="text" :placeholder="translate('search')" v-model:value="filter" class="mb-2"/>
    <div v-for="module in modules" :key="module.key" class="d-flex flex-column g-2">
      <h3 class="mb-0">
        {{ module.name }}
      </h3>
      <div v-if="module.enabled" class="list-group">
        <div class="list-group-item list-group-item-action" v-for="action in module.items" :key="action.key" :class="{ disabled: !module.enabled }" @click="$emit('selected', action.key)">
          <div class="d-flex align-items-center g-2">
            <i :class="action.icon"></i>
            <span>{{ action.title }}</span>
          </div>
          <div v-if="action.description" class="text-muted small mt-2">
            {{ action.description }}
          </div>
        </div>
      </div>
      <div v-else class="text-muted small">
        {{ translate("moduleNotEnabled") }}
      </div>
    </div>
    <div v-if="filter && modules.length === 0">

    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {InputView} from "@/niftybit";

const props = defineProps({
  trigger: Object,
  actions: Array
});

const emit = defineEmits(["selected"]);

const filter = ref("");

const filtered = computed(() => (filter.value.length === 0 ? props.actions : props.actions.filter(item => item.title.toLowerCase().includes(filter.value.toLowerCase()) || item.module.name.toLowerCase().includes(filter.value.toLowerCase()))).sort((a, b) => (b.module.enabled ? 1 : 0) - (a.module.enabled ? 1 : 0)));
const modules = computed(() => {
  let list = [...new Set(filtered.value.map(item => item.module.key))];
  return list.map(moduleKey => {
    return Object.assign(filtered.value.find(item => item.module.key === moduleKey).module, {
      items: filtered.value.filter(item => item.module.key === moduleKey)
    });
  });
});

</script>